module.exports = __webpack_public_path__ + "static/media/slider5.79dfad61.png";